import { css } from '@emotion/css';

export const segmentStyles = css({
  minWidth: '150px',
});
